import currencyFormatter from "currency-formatter";

const data = {
  "MMK": {
    'weight': 0,
  },
  "THB": {
    'weight': 1,
  },
  "CNY": {
    'weight': 2,
  },
  // "USDT": {
  //   'weight': 3,
  // },
  // "USD": {
  //   'weight': 4,
  // },
};


function isMMKTHB({ boughtCurrency, soldCurrency }) {
  return (boughtCurrency === "MMK" && soldCurrency === "THB") || (boughtCurrency === "THB" && soldCurrency === "MMK");
}

function isTHBCNY({ boughtCurrency, soldCurrency }) {
  return (boughtCurrency === "CNY" && soldCurrency === "THB") || (boughtCurrency === "THB" && soldCurrency === "CNY");
}

function isMMKCYN({ boughtCurrency, soldCurrency }) {
  return (boughtCurrency === "MMK" && soldCurrency === "CNY") || (boughtCurrency === "CNY" && soldCurrency === "MMK");
}

const all = Object.keys(data);

const weight = all.reduce((i, c) => {
  i[c] = data[c].weight; return i;
}, {});

const currency = {
  format: (value, precision = 0, currencyCode) => {
    return currencyFormatter.format(value, { precision, code: currencyCode });
  },

  all: all,

  options: all.map((v) => ({ value: v, label: v })),

  calculateResult: ({ rate, fromAmount, fromCapital, toCapital }) => {
    if (isMMKTHB({ boughtCurrency: fromCapital.currency, soldCurrency: toCapital.currency })) {
      rate = 100000 / rate;
    }
    if (isTHBCNY({ boughtCurrency: fromCapital.currency, soldCurrency: toCapital.currency })) {
      rate = rate / 100;
    }
    // MMK to CNY is different, because we need to convert MMK to THB first, then THB to CNY
    if (isMMKCYN({ boughtCurrency: fromCapital.currency, soldCurrency: toCapital.currency })) {
      const [mmkToTHBRate, thbToCNYRate] = rate.split(/\s+/); // example 765 470
      rate = (100000 / mmkToTHBRate) * (thbToCNYRate / 100);
    }

    if (weight[fromCapital.currency] > weight[toCapital.currency]) {
      console.log("from bigger than to");
      return ((fromAmount / toCapital.worth) * rate).toFixed(0);
    } else {
      console.log("to bigger than from");
      return ((fromAmount / toCapital.worth) / rate).toFixed(0);
    }
  },

  calculateExchnageRate: ({ boughtCurrency, soldCurrency, boughtAmount, soldAmount, splitter = "|" }) => {
    if (!boughtAmount || !soldAmount) return (0).toFixed(2);
    let from = boughtAmount;
    let to = soldAmount;

    if (weight[boughtCurrency] > weight[soldCurrency]) {
      from = soldAmount;
      to = boughtAmount;
    }

    const standardRate = from / to;
    if (isMMKTHB({ boughtCurrency, soldCurrency })) {
      return `${(100000 / standardRate).toFixed(2)}\n${splitter} ${standardRate.toFixed(2)}`;
    }

    if (isTHBCNY({ boughtCurrency, soldCurrency })) {
      return `${(standardRate * 100).toFixed(2)}\n${splitter} ${standardRate.toFixed(2)}`;
    }

    return standardRate.toFixed(2);
  },

  rememberExchangeRate: ({ rate, currencyPair }) => {
    localStorage.setItem(currencyPair, rate);
  },

  getRememberExchangeRate: ({ currencyPair }) => {
    return localStorage.getItem(currencyPair);
  }
};

export default currency;
